/*eslint react-hooks/exhaustive-deps: "off"*/
import {useContext, useEffect} from "react";
import useCancelableAxiosGet from "../../utils/hooks/useCancelableAxiosGet";
import MapPropsContext from "./MapPropsContext";
import {getApiUrl} from "../../utils";
import useDebounce from "../../utils/hooks/useDebounce";


function useRequestApiForMapViewport(setResponse) {
  const {
    viewState,
    visibleRadius,
    geojsonExtraParams,
    widgetState,
    isIgnoreCenterChangeEvent,
  } = useContext(MapPropsContext);

  const {
    setIsEnable,
    setUrl,
    setConfig,
    response,
  } = useCancelableAxiosGet();

  let apiUrl = getApiUrl({ type: '' });  // 1) type 미지정, 2) type1, 3) type2

  const {latitude, longitude, zoom} = viewState;

  useDebounce(
    () => {
      const {currentDistrictCode} = geojsonExtraParams;

      if (!isIgnoreCenterChangeEvent) {
        if (widgetState) {
          // 공용화가능 무선국 찾기에서 시도 단위는 요청을 보내지 않도록 설정합니다.
          const {imCellularCommonSido} = widgetState;
          const isEnable = !(imCellularCommonSido && currentDistrictCode && currentDistrictCode.length === 2);
          setIsEnable(isEnable);
        } else {
          setIsEnable(true);
        }

        setUrl(apiUrl);

        const params = {latitude, longitude, zoom, visibleRadius, ...geojsonExtraParams};
        setConfig({params});
      }
    },
    1000,
    [isIgnoreCenterChangeEvent, latitude, longitude, zoom, visibleRadius, geojsonExtraParams]);

  useEffect(() => {
    setResponse(response);
  }, [response]);

  return {
    setIsEnable,
  }
}


export default useRequestApiForMapViewport;
